import React from 'react'
// import * as pt from 'prop-types';
// import ModeSelect from './ModeSelect';

export default function StepBar(props) {
  const { active, steps, selectStep } = props
  const length = steps.length

  let rendered = []

  if (length > 0) {
    steps.map(function (s, i) {
      rendered.push(
        <li
          style={{width: `${100/length}%`}}
          key={i}
          className={
            'step' +
            (active === i ? ' active ' : '') +
            (s.hasError ? ' has-error ' : '')
          }
        >
          <a
            href='javascript:;'
            title={'Step ' + (i + 1)}
            onClick={selectStep.bind(null, i)}
          >
            <span className='icon'>{s.icon}</span>
          </a>
          <span className='title'>
            <em>{i + 1}.</em> <strong>{s.name}</strong>
          </span>
        </li>
      )
    })

    return (
      <div id='step-bar'>
        <div id='progress-line' className={'count-' + length} />
        <ul className=''>{rendered}</ul>
      </div>
    )
  }

  return null
}

// StepBar.propTypes = {};
